import Channels from './Attendance';

export default Channels;
